export const scrollToFirstElementWithClass = (className: string) => {
    const element = document.querySelector(`.${className}`);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
